'use client';

import Link from 'next/link';

const FOOTER_LINKS = [
  { label: 'About', href: '/about' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
  { label: 'Contact', href: 'mailto:support@setscreen.app' },
] as const;

const SOCIAL = [
  { label: 'X (Twitter)', href: 'https://twitter.com/SetScreenApp', icon: 'X' },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/setscreen', icon: 'in' },
  { label: 'YouTube', href: 'https://youtube.com/@SetScreenApp', icon: '▶' },
] as const;

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="border-t border-[var(--landing-border)] bg-black py-16 px-4"
      role="contentinfo"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <p className="font-heading text-lg font-bold text-white">Set Screen</p>
            <p className="mt-1 text-sm text-[var(--landing-muted)]">Precision for Props.</p>
          </div>
          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
              Links
            </h3>
            <ul className="mt-4 space-y-2">
              {FOOTER_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-[var(--landing-muted)] hover:text-white focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-blue)] focus:ring-offset-2 focus:ring-offset-black"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
              Social
            </h3>
            <ul className="mt-4 flex gap-4">
              {SOCIAL.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[var(--landing-border)] text-white hover:border-[var(--landing-accent-blue)] hover:text-[var(--landing-accent-blue)] focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-blue)] focus:ring-offset-2 focus:ring-offset-black"
                    aria-label={s.label}
                  >
                    <span className="text-xs font-medium">{s.icon}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className="mt-12 border-t border-[var(--landing-border)] pt-8 text-center text-sm text-[var(--landing-muted)]">
          © {year} Set Screen. All rights reserved.
        </p>
        <p className="mt-2 text-center text-xs text-[var(--landing-muted)]/80">
          Instant Prop Screen Sync for Film Sets
        </p>
      </div>
    </footer>
  );
}
